<template>
  <div class="relative w-full">
    <div class="absolute inset-y-0 left-4 flex items-center pointer-events-none">
      <SearchIcon
        class="h-4 w-4 text-gray-600"
        aria-hidden="true"
      />
    </div>
    <input
      ref="searchInputRef"
      v-bind="$attrs"
      class="w-full pl-10"
      type="text"
      autocapitalize="off"
      autocorrect="off"
      :placeholder="placeholder"
      v-model="searchQuery"
      @blur="handleBlur"
      @focus="handleFocus"
    />
  </div>
</template>

<!--
@Todo: This can be moved once on Vue 3.3
See: https://blog.vuejs.org/posts/vue-3-3#defineoptions
-->
<script>
export default {
  inheritAttrs: false
}
</script>

<script setup>
import { ref, watch, onMounted } from 'vue'
import { useDebounceFn } from '@vueuse/core'
import { SearchIcon } from '@heroicons/vue/solid'

const props = defineProps({
  minChars: {
    type: Number,
    default: 2
  },
  selectedValue: {
    type: String
  },
  placeholder: {
    type: String,
    default: 'Search'
  },
  autoFocus: {
    type: Boolean,
    default: false
  }
})

const searchInputRef = ref()

const emit = defineEmits(['search', 'blur', 'focus'])

const searchQuery = ref('')
let blurTimeout = null

watch(
  () => props.selectedValue,
  (newValue) => {
    searchQuery.value = newValue ?? ''
  },
  { immediate: true }
)

const debouncedSearch = useDebounceFn((query) => {
  if (!props.selectedValue && query.length >= props.minChars) {
    emit('search', query)
  }
}, 300)

watch(searchQuery, (newValue) => {
  debouncedSearch(newValue)
})

function handleBlur() {
  blurTimeout = setTimeout(() => {
    emit('blur')
  }, 200)
}

function handleFocus() {
  if (blurTimeout) {
    clearTimeout(blurTimeout)
  }
  emit('focus')
}

onMounted(() => {
  if (props.autoFocus) {
    searchInputRef.value.focus()
  }
})
</script>
